import {ErrorMessage, Field} from 'formik';
import _ from 'lodash';
import React from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';

import {FormLabel} from '../../../ui-toolkit/indexExportV2';

import {useEntityList} from '../../../ducks/entity-list-v2';
import {getFkOptionsSpecification} from '../../../ducks/fkoptionshelper';
import {
    getForeignKeyEntityDataType,
    getPathDetails,
    unwrapNullableDataType,
} from '../../../ducks/formattersettingshelpers';
import {useTypeDetail} from '../../../ducks/typedetail-flattened';
import {SelectionControl} from '../../../ui-toolkit/form-v2/form-control-type/selection-controls/SelectionControl';
import {FormErrorMessage} from '../../../ui-toolkit/form-v2/form-labels/FormErrorMessage';
import {useFormatterById} from '../../FormattersContext';
import ToJsonFormatter from './ToJsonFormatter';

function FKRadioEditor({
    formatter,
    fieldName,
    entityType: dataType,
    parentTypeId,
    entityAttributeId,
    attributePath,
    t,
}) {
    const entityType = unwrapNullableDataType(dataType);
    const subFormatter = useFormatterById(formatter.settings.entryFormatterId);
    const parentDataType = useTypeDetail(parentTypeId);
    const childDataType = getForeignKeyEntityDataType(entityType);

    const attribute = getPathDetails(parentDataType, attributePath ?? entityAttributeId).finalAttribute;
    const extraFilter = getFkOptionsSpecification(parentDataType, childDataType, attribute.attributeName);

    const {entities, isLoading} = useEntityList(childDataType.dataTypeId, {
        filter: extraFilter,
        pageSize: 99999,
        project: subFormatter.projectionFunction(subFormatter.settings),
    });

    let FieldFormatter = {Formatter: ToJsonFormatter};
    if (subFormatter) FieldFormatter = subFormatter;

    if (parentDataType == null || isLoading) {
        return <p>{t('generalShared.loading')}</p>;
    }

    let uid = _.uniqueId('input');
    return (
        <Wrapper>
            {formatter.settings.allowNull && (
                <SelectionControl radio htmlFor={uid + '_null'} label="-">
                    <Field name={fieldName}>
                        {({field}) => (
                            <input
                                {...field}
                                type="radio"
                                name={field.name}
                                id={uid + '_null'}
                                checked={!_.get(field, 'value.entityId', _.get(field, 'value'))}
                                onChange={() => field.onChange(field.name)('')}
                                className="form-check-input"
                            />
                        )}
                    </Field>
                </SelectionControl>
            )}

            {entities.map((eo, ix) => (
                <SelectionControl
                    key={ix}
                    htmlFor={uid + ix}
                    radio
                    label={
                        <FormLabel htmlFor={uid + ix}>
                            <FieldFormatter.Formatter
                                entityType={entityType.entityDataType}
                                formatter={subFormatter}
                                entity={eo}
                            />
                        </FormLabel>
                    }>
                    <Field name={fieldName}>
                        {({field}) => (
                            <input
                                {...field}
                                type="radio"
                                name={field.name}
                                id={uid + ix}
                                checked={
                                    _.get(eo, 'entityId') === _.get(field, 'value.entityId', _.get(field, 'value'))
                                }
                                onChange={() => field.onChange(field.name)(eo.entityId)}
                                className="form-check-input"
                            />
                        )}
                    </Field>
                </SelectionControl>
            ))}

            <ErrorMessage name={fieldName} component={FormErrorMessage} />
        </Wrapper>
    );
}

export default withTranslation()(FKRadioEditor);

const Wrapper = styled.div`
    margin: 0 0 var(--space-md);
    * {
        margin: 0;
    }
`;
